var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card-actions',[_c('v-row',{staticClass:"mt-1"},[_c('v-col',[_c('btn-voltar',{attrs:{"to":"/planos"}})],1)],1)],1),_c('planos-campos',{attrs:{"carregando-salvar":_vm.carregando,"validacao-formulario":_vm.validacaoFormulario},on:{"salvar":_vm.salvar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }